export default "__VITE_ASSET__DMKQi9UF__"